import React, {useEffect, useRef, useState} from "react";
import {AdsAvailable} from "../pages/types";
import {getAdsAvailable, getAdsVisit} from "../service";
import useUserInfo from "../routers/useUserInfo";
import {getAdsID, setAdsID} from "../units";
import {useLoading} from "./loading/LoadingProvider";
import btn from '../images/adsBtn.png'

function UserAds(){

    const [ads,setAds] = useState<AdsAvailable | null>()
    const [showAds,setShow] = useState(false)
    const user = useUserInfo(false)
    const adsID = getAdsID()
    const isLoad = useRef(false)
    const loading = useLoading()

    useEffect(() => {
        if(!isLoad.current){
            getAdsAvailable({
                userId:user?.id
            }).then(res => {
                if(res.code === 1){
                    setAds(res.data)
                    if(res.data && (!adsID || adsID !== res.data.id) && !res.visited){
                        setShow(true)
                    }
                }
            })
        }
    },[user])

    const handleCancel = () => {
        setShow(false)
    }

    const handleAds = () => {
        if(ads){
            if(user){
                loading.showLoading()
                setAdsID(ads.id)
                getAdsVisit({
                    userId:user.id,
                    adId:ads.id
                }).then(() => {
                    loading.hideLoading()
                    window.location.href = ads.targetHref
                }).catch(() => {
                    loading.hideLoading()
                    window.location.href = ads.targetHref
                })
            }else{
                setAdsID(ads.id)
                window.location.href = ads.targetHref
            }
        }
    }

    if(!ads){
        return  null
    }

    if(!showAds){
        return <div className="ads-btn" onClick={ () => setShow(true) }>
            <img src={ btn } alt=""/>
        </div>
    }

    return <div className="user-ads">
        <div className="ads-box">
            <img src={ ads?.coverUrl } onClick={handleAds} alt=""/>
            <p className="iconfont" onClick={handleCancel}>&#xe611;</p>
        </div>
    </div>
}

export default UserAds